import { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Col, Form, Row } from "react-bootstrap"
import { getUrlSearchParams } from "../../urlParams"
import { ApiEndpoints, reqPatch, reqPostNew, reqPut } from "../../../config/apiClient"
import removeAllErrorMsg from "../../../components/funcRemoveAllErros"
import funcSleep from "../../../components/funcSleep"
import LoadingModal from "../../../components/loadingModal"
import { defineValueInInput } from "../../../components/funcForInput"
import { iDespesasCategoriaDto } from "../dto/despesas_categorias"

function DespesasCategoriasFormPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [categoriaDados, setCategoriaDados] = useState<iDespesasCategoriaDto | any>({})

    useEffect(() => {
        document.title = "Cadastrar Categoria | OB PORTUS"

        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")

        const getDados = async (id:number) => {
            setLoading(true)

            const dados = {
                id_categoria: Number(id)
            }

            const api = await reqPostNew(ApiEndpoints.despesasCategoriaConsultar, dados)

            if (api.status === 200) {
                const categoria:iDespesasCategoriaDto = api.data
                setCategoriaDados(categoria)
                defineValueInInput('descricao', categoria.descricao)
                defineValueInInput('status', categoria.ativo)
                defineValueInInput('veiculo', categoria.veiculo)
                defineValueInInput('km', categoria.km)
                defineValueInInput('litros', categoria.litros)
            }

            setLoading(false)
        }

        if (id !== null) {
            getDados(Number(id))
            document.title = "Editar Categoria | OB PORTUS"
        }
    }, [])

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados:iDespesasCategoriaDto = {
            id_categoria: Object.values(categoriaDados).length === 0 ? 0 : categoriaDados.id_categoria,
            descricao: form.descricao.value,
            veiculo: Number(form.veiculo.value),
            km: Number(form.km.value),
            litros: Number(form.litros.value),
            ativo: Number(form.status.value)
        }

        if (dados.descricao === "") {
            form.descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }

        console.info(dados)

        if (!formValidado) {
            return
        }

        if (Object.values(categoriaDados).length === 0) {
            cadastrar(dados)
        }

        if (Object.values(categoriaDados).length > 0) {
            editar(dados)
        }
    
    }

    async function cadastrar(dados:iDespesasCategoriaDto) {

        setLoading(true)

        const api = await reqPut(ApiEndpoints.despesasCategoriaCadastrar, dados)

        if (api.status === 201) {
            console.log(api.data)

            toast.success('Categoria cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/despesas/categorias`)
        }
        setLoading(false)

    }

    async function editar(dados: iDespesasCategoriaDto) {
        setLoading(true)

        const api = await reqPatch(ApiEndpoints.despesasCategoriaEditar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Categoria editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/despesas/categorias`)
        }

        setLoading(false)
    }

    async function handleExcluirTipo() {
        if (!window.confirm('Tem certeza que deseja excluir a Categoria?')) {
            return
        }

        const dados = {
            id_categoria: categoriaDados.id_categoria
        }

        setLoading(true)

        const api = await reqPostNew(ApiEndpoints.despesasCategoriaDeletar, dados)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Categoria excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/despesas/categorias`)
        }

        setLoading(false)

    }
    
    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event:any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
            <h1 id="titleMain">Despesas Categoria</h1>
            <Button variant="secondary" onClick={() => {window.location.assign(`/despesas/categorias`)}}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formDespesasCategoria' onSubmit={handleSubmit} noValidate>

                <Row className="mb-15-forms">
                    <Col className="col-6">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='descricao' type="text" id='descricao' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Status:</Form.Label>
                            <Form.Select name="status" id="status" aria-label="">
                                <option value="1">Ativo</option>
                                <option value="0">Desativado</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe o Status!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Necessário informar veículo:</Form.Label>
                            <Form.Select name="veiculo" id="veiculo" aria-label="">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Necessário informar KM:</Form.Label>
                            <Form.Select name="km" id="km" aria-label="">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Necessário informar litros:</Form.Label>
                            <Form.Select name="litros" id="litros" aria-label="">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                {
                    Object.values(categoriaDados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(categoriaDados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading} style={{marginRight: '10px'}}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }

                {
                    Object.values(categoriaDados).length > 0 &&
                    <Button variant="danger" disabled={loading} style={{marginRight: '10px'}} onClick={() => {handleExcluirTipo()}}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                }
            </Form>
        </div>
    )
}

export default DespesasCategoriasFormPage